import React from "react";
import mockupimage from "../../assets/images/media/mockup-image.webp"
import socialmedia from "../../assets/images/media/socialmedia.webp"
import { LazyLoadImage } from "react-lazy-load-image-component";

const LinkYourStoreBanner = () => {
  return (
    <div className="contact-section-three image-bg pt-150 pb-150 lg-pt-100 lg-pb-100 flex justify-center" data-aos="fade-up" >
      <div className="flex flex-col justify-center items-center">
        <LazyLoadImage src={mockupimage} alt='mockupimage' />
        <LazyLoadImage src={socialmedia} alt='socialmedia' />
      </div>
    </div >
  );
};

export default LinkYourStoreBanner;